"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ledgers = exports.Ledger = void 0;
class Ledger {
    constructor(ledger) {
        this.id = '';
        this.date = new Date();
        this.coin = '';
        this.description = '';
        this.value = 0;
        this.balance = 0;
        if (!ledger)
            return;
        this.id = ledger.id;
        this.date = ledger.date;
        this.coin = ledger.coin;
        this.description = ledger.description;
        this.value = ledger.value;
        this.balance = ledger.balance;
    }
}
exports.Ledger = Ledger;
class Ledgers {
    constructor(ledgers) {
        this.list = [];
        if (!ledgers)
            return;
        this.list = ledgers.list;
    }
}
exports.Ledgers = Ledgers;
//# sourceMappingURL=ledger.js.map